// Timer disble fuction
function disablePastTimes() {
    let now = new Date();
    let currentHours = now.getHours();
    let currentMinutes = now.getMinutes();
    let selectedDate = new Date(document.getElementById("datePicker").value);
    let today = new Date();

    let timeButtons = document.querySelectorAll(".time-buttons button");

    timeButtons.forEach(button => {
        let [hours, minutes] = button.innerText.split(":").map(Number);

        if (selectedDate.toDateString() === today.toDateString()) {
           
            if (hours < currentHours || (hours === currentHours && minutes < currentMinutes) || hours === currentHours + 1) {
                button.classList.add("disabled");
                button.disabled = true;
                button.style.background = "#ddd";
                button.style.cursor = "not-allowed";
            } else {
                button.classList.remove("disabled");
                button.disabled = false;
                button.style.background = "white"; 
                button.style.cursor = "pointer";
            }
        } else {
            button.classList.remove("disabled");
            button.disabled = false;
            button.style.background = "white";
            button.style.cursor = "pointer";
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    let datePicker = document.getElementById("datePicker");

    
    let today = new Date();
    let todayString = today.toISOString().split("T")[0];
    datePicker.value = todayString;
    datePicker.setAttribute("min", todayString); 

    disablePastTimes();

  
    datePicker.addEventListener("change", disablePastTimes);

   
    document.querySelectorAll(".time-buttons button").forEach(button => {
        button.addEventListener("click", function () {
            if (this.classList.contains("disabled")) {
                return; 
            }

            document.querySelectorAll(".time-buttons button").forEach(btn => {
                if (!btn.classList.contains("disabled")) { 
                    btn.classList.remove("selected");
                    btn.style.background = "white"; // Default background
                }
            });

            this.classList.add("selected");
            this.style.background = "#8bc34a"; 
        });
    });
});


// ----------- 2. PRE-BOOKING BUTTON FOR SPECIFIC PRODUCT ----------- //


document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;

  // ✅ Pre-booking copy per product handle
  const prebookContent = {
    "spacebike-x-electric-bike": {
      title: "Pre-book the Spacebike X Today!",
      subtitle: "Be the first to ride when it’s back in stock.",
    },
    "pathfinder-electric-bike": {
      title: "Pre-book the Pathfinder Today!",
      subtitle: "Be the first to ride when it’s back in stock.",
    },
    "explorer-mini-electric-vehicle": {
      title: "Pre-book the Explorer Mini Today!",
      subtitle: "Be the first to ride when it’s back in stock.",
    },
    "3-wheel-drifter-electric-ride-on-car": {
      title: "Pre-book the Drifter Today!",
      subtitle: "Be the first to ride when it’s back in stock.",
    }
  };

  // ✅ Get product handle from URL
  const handle = currentPath.split("/products/")[1]?.split("?")[0]?.replace("/", "");
  if (!prebookContent[handle]) return;

  // ⏳ tiny helper to wait for elements
  function waitForElement(selector, cb, retries = 30) {
    const el = document.querySelector(selector);
    if (el) return cb(el);
    if (retries <= 0) return;
    setTimeout(() => waitForElement(selector, cb, retries - 1), 200);
  }

  // ⏳ Wait for the button container to exist
  waitForElement(".min-btn-bx", function (minBtnBx) {
    // 🚫 Remove/Hide SALE badge(s)
    document.querySelectorAll(".product__sale").forEach(el => {
      // choose one:
      // el.style.display = "none";    // hide only
      el.remove();                     // completely remove
    });

    // 🚫 Hide default button sections
    document.querySelectorAll(".min-btn-bx").forEach(el => (el.style.display = "none"));

    // 🚫 Hide original Buy It Now buttons (if any)
    document.querySelectorAll(".mm-add-to-cart.product__submit__add--default").forEach(btn => {
      btn.style.display = "none";
    });

    // ✅ Insert pre-booking UI (once)
    if (!document.querySelector(".prebook-section")) {
      const { title, subtitle } = prebookContent[handle];

      const container = document.createElement("div");
      container.classList.add("prebook-section");
      container.style.marginTop = "20px";
      container.innerHTML = `
        <div class="pre-info" style="padding:15px;background:#fffbf5;border:1px solid #f2c97d;margin-bottom:15px;font-size:16px;line-height:1.6;border-radius:12px;">
          <strong>${title}</strong><br>
          ${subtitle}<br>
          Pay just ₹1000 token amount today.<br>
          <span style="color:green;font-weight:700 !important;">Flat 10% off – only for pre-booking customers!</span>
          <label style="font-size:14px;display:flex;gap:8px;align-items:center;margin-top:10px;">
            <input type="checkbox" id="prebook-checkbox">
            Booking amount is Non-refundable
          </label>
        </div>
        <button id="prebooking-btn-main" class="btn btn--primary pre-booking-btn btn-fade" style="margin-top:12px;display:block;" disabled>
          <span class="btn__text">Pre-Book Now for ₹1000</span>
        </button>
        <p style="color:red;font-size:14px;margin-top:8px;margin-bottom:15px;">
          Pay ₹1000 now to reserve. Remaining amount will be collected before dispatch.
        </p>
      `;

      // place after the hidden button block
      minBtnBx.parentNode.insertBefore(container, minBtnBx.nextSibling);

      const checkbox = container.querySelector("#prebook-checkbox");
      const mainBtn  = container.querySelector("#prebooking-btn-main");

      // ♻️ shared click handler
      function handlePreBooking(e) {
        if (!checkbox.checked) return;
        e.preventDefault();

        const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
        const selectedVariantId = variantInput?.value;

        if (!selectedVariantId) {
          alert("Please select a variant before pre-booking.");
          return;
        }

        // add to cart as normal (qty 1); change to token product if needed
        window.location.href = `/cart/add?id=${selectedVariantId}&quantity=1`;
      }

      // enable/disable all pre-book buttons together
      checkbox.addEventListener("change", function () {
        document.querySelectorAll(".pre-booking-btn").forEach(btn => {
          if (this.checked) { btn.removeAttribute("disabled"); btn.classList.remove("btn-fade"); }
          else { btn.setAttribute("disabled", "true"); btn.classList.add("btn-fade"); }
        });
      });

      mainBtn.addEventListener("click", handlePreBooking);

      // ✅ Clone button into sticky cart bar (if present)
      waitForElement(".cart-bar__form", function (cartBarForm) {
        const stickyBtn = mainBtn.cloneNode(true);
        stickyBtn.id = "prebooking-btn-sticky";
        cartBarForm.appendChild(stickyBtn);
        stickyBtn.addEventListener("click", handlePreBooking);
      });
    }
  });
});



// ------ video call hide sold item -------
document.addEventListener("DOMContentLoaded", function () {
  var productObj = window.meta?.product || window.product;
  var videoSec = document.querySelector('.video-call-sec');

  if (!productObj || typeof productObj.available === 'undefined' || !videoSec) return;

  if (productObj.available === true || productObj.available === "true") {
    videoSec.style.display = "";
    // console.log("In Stock: Show video-call-sec");
  } else {
    videoSec.style.display = "none";
    // console.log("Sold Out: Hide video-call-sec");
  }
});



// -------- book a demo form -----


document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("ajax-form1");
  const timeButtons = document.querySelectorAll(".select-time");

  // Highlight selected time
  timeButtons.forEach(btn => {
    btn.addEventListener("click", function () {
      timeButtons.forEach(b => b.classList.remove("active"));
      this.classList.add("active");
    });
  });

  // Form submit
  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const selectedBtn = document.querySelector(".select-time.active");
    if (!selectedBtn) {
      alert("Please select a time slot.");
      return;
    }

    // ✅ Detect product name
    const productTitleElement =
      document.querySelector("h1.product__title") ||
      document.querySelector(".product-title") ||
      document.querySelector("meta[property='og:title']");

    let productName = "Unknown Product";
    if (productTitleElement) {
      if (productTitleElement.textContent) {
        productName = productTitleElement.textContent.trim();
      } else if (productTitleElement.getAttribute("content")) {
        productName = productTitleElement.getAttribute("content").trim();
      }
    } else if (window.location.href.includes("/products/")) {
      productName = decodeURIComponent(
        window.location.href.split("/products/")[1].replace(/[-_]/g, " ")
      );
    }

    // ✅ Capture URL and Product name correctly
    const data = {
      name: form.name.value.trim(),
      email: form.email.value.trim(),
      phone: form.phone.value.trim(),
      date: form.date.value.trim(),
      time: selectedBtn.dataset.time,
      page_url: window.location.href,
      product_name: productName
    };

    console.log("📤 Data sent:", data); // ✅ Check in browser console

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbw0iMNADOQm1JFs9orinJBq5hCu6nSwNjV42RPecfNaZAGFjVpzFMcvzRXELq-SMGE/exec";

    try {
      await fetch(scriptURL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      alert("✅ Your demo booking has been submitted successfully!");
      form.reset();
      timeButtons.forEach(b => b.classList.remove("active"));
    } catch (err) {
      alert("❌ Error submitting form. Please try again later.");
      console.error(err);
    }
  });
});


// -------------


 document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/pages/cxm") {
      var header = document.querySelector(".header__wrapper");
      if (header) {
        header.style.display = "none";
      }
    }
  });


  document.querySelectorAll('.whatmore-carousel-events p').forEach(el => {
  if (el.innerText.toLowerCase().includes('off')) {
    el.style.setProperty('color', '#000', 'important');
  }
});